import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { ArrowRoundedRight, ArrowRoundedRightup } from '@aok/icon-functional'
import { ContextHeadline } from '@aok/text-elements'

import defaultProps from '../../../utils/propTypes/defaultProps'
import { ColorScheme } from '../../../utils/defaultTypes'

const LinkTitle = ({
  url,
  title,
  className,
  theme,
  underline,
  target,
  hasDefaultFontSize,
  asHeadline,
  alwaysShowDefaultArrow,
  children,
  ...rest
}) => {
  const textClasses = classnames({
    'text-005e3f hover:text-18ab42 group-hover:text-18ab42 focus:text-18ab42 ': theme !== ColorScheme.DARK,
    'text-ffffff hover:text-50eb5d group-hover:text-50eb5d focus:text-50eb5d': theme === ColorScheme.DARK,
    'hyphens': /&shy/g.test(title) === false,
  })

  const borderClasses = classnames({
    'border-b border-005e3f group-hover:border-18ab42 focus-visible:border-18ab42': theme !== ColorScheme.DARK,
    'border-b border-ffffff group-hover:border-50eb5d focus-visible:border-50eb5d': theme === ColorScheme.DARK,
  })

  const iconClasses = `w-16 h-16 ml-8 fill-current inline transition-transform ease-in-out duration-350 group-hover:scale-120
    ${hasDefaultFontSize ? 'mb-4' : 'mb-2'}`

  return (
    <a
      href={url}
      rel={target === '_blank' ? 'noopener noreferrer' : null}
      target={target}
      className={`font-buenos-aires font-semibold group
        ${className}
        ${textClasses}
        ${children ? 'flex items-center' : ''}
        ${hasDefaultFontSize ? 'text-20 leading-28' : ''}
      `}
      {...rest}
    >
      {children}
      <ContextHeadline tag={asHeadline ? null : 'p'}>
        <span className={`block ${children ? 'ml-16' : ''}`}>
          <span className={underline ? `${borderClasses}` : ''} dangerouslySetInnerHTML={{ __html: title }} />
          {target === '_blank' && !alwaysShowDefaultArrow ? (
            <ArrowRoundedRightup className={iconClasses} />
          ) : (
            <ArrowRoundedRight className={iconClasses} />
          )}
        </span>
      </ContextHeadline>
    </a>
  )
}

LinkTitle.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
  underline: PropTypes.bool,
  target: PropTypes.oneOf(['_blank', '_self']),
  hasDefaultFontSize: PropTypes.bool,
  theme: PropTypes.oneOf([ColorScheme.LIGHT, ColorScheme.DARK, ColorScheme.STRUCTURE]),
  asHeadline: PropTypes.bool,
  alwaysShowDefaultArrow: PropTypes.bool,
}

LinkTitle.defaultProps = {
  theme: 'light',
  underline: false,
  target: '_self',
  url: defaultProps.URL,
  title: defaultProps.TITLE,
  hasDefaultFontSize: true,
  className: '',
  asHeadline: true,
  alwaysShowDefaultArrow: false,
}

export default LinkTitle
